import { render, staticRenderFns } from "./upload-file-array.vue?vue&type=template&id=810abad4&scoped=true&"
import script from "./upload-file-array.vue?vue&type=script&lang=js&"
export * from "./upload-file-array.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810abad4",
  null
  
)

export default component.exports